module.exports = __webpack_public_path__ + "img/Radio_Button_Filled_Black.c092d2c8.svg";